export default __webpack_public_path__ + "static/logo-accessibility-81499f2e6359c238d066d402d392aa3e.svg";